import tvgConf from "@tvg/conf";
import { getPortByBrand } from "@tvg/utils/generalUtils";
import { get } from "lodash";

const conf = tvgConf();

const POLL_INTERVAL = 60000;

export default {
  skip: (props) => !props.matchRaces.length,
  options: (props) => {
    const variables = {
      wagerProfile: get(props, "wagerProfile") || getPortByBrand(),
      matchRaces: get(props, "matchRaces", []),
      isOpen: true,
      isGreyhounds: false,
      ...conf.graphContext()
    };

    return {
      pollInterval: POLL_INTERVAL,
      fetchPolicy: "cache-and-network",
      ssr: false,
      variables
    };
  },
  props: (result) => ({
    races: get(result, "data.races", []),
    refetch: (variables) => result.data.refetch(variables)
  })
};
